import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToHashElement() {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const element = document.getElementById(hash.replace('#', ''));
      if (element) {
        const offset = -80; // adjust this value to scroll "a little above"
        const elementTop = element.getBoundingClientRect().top + window.pageYOffset;
        const scrollTo = elementTop + offset;

        window.scrollTo({ top: scrollTo, behavior: 'smooth' });
      }
    }
  }, [hash]);

  return null;
}
